module.exports = __webpack_public_path__ + "static/media/svetoslav-400-400.a8c4a88b.webp";